import { Dayts, QueryInputType, queryInput } from '@/utils';
import { ImportWithAirport, ImportWithAirportConnectionInput } from '@/models/gen/graphql';

import { DATETIME_RFC_FORMAT } from '@/constants';
import { ManifestsTypes } from '@/features/Manifests/types';
import { SearchManifestTableDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runRefetchSearchManifestTable] = graphApi(SearchManifestTableDocument);

const searchManifestTable = async (...queries: ManifestsTypes.Query[]) => {
  const input: ImportWithAirportConnectionInput = {
    first: 1000,
    after: null,
    query: queries.map((query) => ({
      createdAt: queryInput(
        [new Dayts(query.from).startOf('day').format(DATETIME_RFC_FORMAT), new Dayts(query.to).endOf('day').format(DATETIME_RFC_FORMAT)],
        QueryInputType.RANGE
      ),
      createdBy: queryInput(query.createdBy, QueryInputType.OR),
      airportCode: queryInput.orNull(query.airportCode, QueryInputType.OR),
      providerId: queryInput.orNull(query.providerId, QueryInputType.OR),
      type: queryInput(query.type, QueryInputType.OR),
      status: queryInput.orNull(query.status, QueryInputType.OR),
      archivedAt: queryInput([], query.archived === true ? QueryInputType.ISNOTNULL : QueryInputType.ISNULL),
    })),
  };

  return await runRefetchSearchManifestTable({ input });
};

export const searchManifestTableWithMetadata = async (...queries: ManifestsTypes.Query[]) => {
  const res = await searchManifestTable(...queries);

  return {
    imports: res?.searchImports?.importWithAirportConnection?.edges.map((edge) => edge.node as unknown as ImportWithAirport) || [],
    totalCount: res?.searchImports?.importWithAirportConnection?.totalCount || 0,
  };
};

export default searchManifestTable;
